const subTitle = "ABOUT MINDCRAFT";
const title = "Tailormade courses to support student learning curves";
const desc = "At MindCraft, we believe that learning should be as dynamic as the students themselves. That's why our private STREAM courses are designed to adapt to each learner's pace, interests, and goals.";

const aboutList = [
    {
        title: '🚀 Hands-On Learning',
    },
    {
        title: '🛠 Engineering-Based Education',
    },
    {
        title: '📚 Project-Based Approach',
    },
    {
        title: '🔄 Flexible & Adaptive',
    },
    {
        title: '🌍 Future-Proof Skills',
    },
]

// Custom styles for overriding the background triangle color
const aboutSectionStyle = `
.about-section::before {
  border-bottom: 753px solid var(--theme-tertiary-color) !important;
  z-index: -1;
}

.about-thumb img {
  max-width: 85%;
  height: auto;
}

@media (max-width: 768px) {
  .about-thumb {
    display: flex;
    justify-content: center;
  }
  
  .about-thumb img {
    max-width: 70%;
    margin: 0 auto;
  }
}
`;

const About = () => {
    return (
        <>
            {/* Inline style tag to override the background triangle color */}
            <style>{aboutSectionStyle}</style>
            
            <div className="about-section">
                <div className="container">
                    <div className="row justify-content-center row-cols-xl-2 row-cols-1 align-items-end flex-row-reverse">
                        <div className="col">
                            <div className="about-right padding-tb">
                                <div className="section-header">
                                    <span className="subtitle">{subTitle}</span>
                                    <h2 className="title">{title}</h2>
                                    <p>{desc}</p>
                                </div>
                                <div className="section-wrapper">
                                    <div className="row">
                                        {aboutList.map((val, i) => (
                                            <div key={i} className="col-md-6 mb-3">
                                                <div className="sr-right">
                                                    <h5>{val.title}</h5>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="about-left">
                                <div className="about-thumb">
                                    <img src="assets/images/about/about_us_guy.png" alt="about" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
 
export default About;